import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { MerchantLogo } from '../../containers'

import { ANALYTICS_HELPER, HISTORY, ROUTE_CONSTANTS, IMAGE_SRC } from '../../utils'
import { useTranslation } from '../../hooks'
import { useSelector } from 'react-redux'

const handleAboutNav = () => {
	ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
		action: ANALYTICS_HELPER.EVENT.NAVIGATION.ABOUT_US.ACTION,
		label: ANALYTICS_HELPER.EVENT.NAVIGATION.ABOUT_US.LABEL,
		properties: {},
	})
	HISTORY.push(ROUTE_CONSTANTS.ABOUT_US)
}

const handlePrivacyNav = () => {
	ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
		action: ANALYTICS_HELPER.EVENT.NAVIGATION.PRIVACY_POLICY.ACTION,
		label: ANALYTICS_HELPER.EVENT.NAVIGATION.PRIVACY_POLICY.LABEL,
		properties: {},
	})
	HISTORY.push(ROUTE_CONSTANTS.PRIVACY_POLICY)
}

export default function HeroBanner({ text, logo_One, heroBanner }) {
	const translate = useTranslation()

	const { browseStores, catalogue_key, additional_details } = useSelector((state) => state.config)
	const { pages } = additional_details || {}

	useEffect(() => {
		let path = window.location.pathname
		if (
			(path === ROUTE_CONSTANTS.ABOUT_US && !pages?.about) ||
			(path === ROUTE_CONSTANTS.PRIVACY_POLICY && !pages?.privacy_policy)
		) {
			HISTORY.goBack()
		}
		ANALYTICS_HELPER._screenShift(ANALYTICS_HELPER.EVENT_STEPS.SHOP, ANALYTICS_HELPER.CATEGORY.SHOP)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleProductNav = () => {
		ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
			action: ANALYTICS_HELPER.EVENT.NAVIGATION.PRODUCTS.ACTION,
			label: ANALYTICS_HELPER.EVENT.NAVIGATION.PRODUCTS.LABEL,
			properties: {},
		})
		HISTORY.push('/' + catalogue_key)
	}

	const moveBackwards = () => {
		if (!browseStores) {
			window.location = process.env.REACT_APP_BSECURE_CUSTOMER_APP_URL
		} else {
			HISTORY.goBack()
		}
	}

	return (
		<div
			className="heroBanner"
			style={{ backgroundImage: `url(${heroBanner || IMAGE_SRC.ABOUT_HEADER})` }}
		>
			<header>
				<div className="container">
					<div className="row">
						<div className="headerNavMLeft">
							<ul>
								<li
									className={window.location.pathname === ROUTE_CONSTANTS.ABOUT_US ? 'active' : ''}
									onClick={handleAboutNav}
								>
									<i className="icons-icon-about"></i>
								</li>
							</ul>
						</div>
						<div className="col-sm-5 headerLogo">
							{isMobile && browseStores ? (
								<div className="back_icon" onClick={moveBackwards}>
									<i className="icons-icon-back"></i>
								</div>
							) : (
								''
							)}
							<div className="logo_One">
								{logo_One ? (
									<img src={logo_One} className={`header-brand-img`} alt={'logo'} />
								) : (
									<MerchantLogo imgClasses="header-brand-img" />
								)}
							</div>
						</div>
						<div className="headerNavD">
							<ul>
								<li
									className={window.location.pathname === ROUTE_CONSTANTS.ABOUT_US ? 'active' : ''}
									onClick={handleAboutNav}
								>
									{translate('GENERAL.ABOUT_US')}
								</li>
								<li onClick={handleProductNav}>{translate('GENERAL.VIEW_PRODUCTS')}</li>
								<li
									className={
										window.location.pathname === ROUTE_CONSTANTS.PRIVACY_POLICY ? 'active' : ''
									}
									onClick={handlePrivacyNav}
								>
									{translate('GENERAL.PRIVACY_POLICY')}
								</li>
							</ul>
						</div>
						<div className="headerNavMRight">
							<ul>
								<li onClick={handleProductNav}>
									<i className="icons-icon-store"></i>
								</li>
								<li
									onClick={handlePrivacyNav}
									className={
										window.location.pathname === ROUTE_CONSTANTS.PRIVACY_POLICY ? 'active' : ''
									}
								>
									<i className="icons-icon-privacy"></i>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</header>
			<div className="heroContent">
				<div className="container">
					<div className="row">
						<div className="col-md-6 col-sm-9">
							<div className="mainContentHero">
								<h1>{text}</h1>
								<div onClick={handleProductNav} className="viewProducts btn btn-sm">
									{translate('GENERAL.VIEW_PRODUCTS')}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
